(() => {
  const STORAGE_PREFIX = 'fb_promo_popup_';
  let openPopup = null;
  let previousFocus = null;

  const storageKey = (id) => `${STORAGE_PREFIX}${id}`;

  const readState = (id) => {
    try {
      return JSON.parse(localStorage.getItem(storageKey(id)) || '{}');
    } catch {
      return {};
    }
  };

  const writeState = (id, value) => {
    try {
      localStorage.setItem(storageKey(id), JSON.stringify(value));
    } catch {}
  };

  const getTeaser = (id) =>
    document.querySelector(`[data-fbp-teaser][data-section-id="${CSS.escape(id)}"]`);

  const deviceMatches = (popup) => {
    const device = popup.dataset.device || 'all';
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    if (device === 'mobile') return isMobile;
    if (device === 'desktop') return !isMobile;
    return true;
  };

  const canDisplay = (popup) =>
    popup.dataset.enabled === 'true' &&
    popup.dataset.pageMatch === 'true' &&
    deviceMatches(popup);

  const isSuppressed = (popup) => {
    const state = readState(popup.dataset.sectionId);
    const now = Date.now();
    const closeDays = Number(popup.dataset.closeDays || 7);
    const successDays = Number(popup.dataset.successDays || 30);

    if (state.successAt && now - state.successAt < successDays * 86400000) return true;
    if (state.closedAt && now - state.closedAt < closeDays * 86400000) return true;
    return false;
  };

  const focusFirst = (popup) => {
    const target = popup.querySelector(
      'input:not([type="hidden"]), button:not([data-fbp-overlay]), a[href], select, textarea'
    );
    target?.focus({ preventScroll: true });
  };

  const show = (popup, force = false) => {
    if (!force && !canDisplay(popup)) return;
    if (openPopup && openPopup !== popup) hide(openPopup, false, false);

    previousFocus = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    popup.hidden = false;
    openPopup = popup;
    document.body.classList.add('fb-promo-popup-open');
    getTeaser(popup.dataset.sectionId)?.setAttribute('hidden', '');
    requestAnimationFrame(() => focusFirst(popup));
  };

  const hide = (popup, remember = true, showTeaser = true) => {
    popup.hidden = true;
    if (openPopup === popup) openPopup = null;
    document.body.classList.remove('fb-promo-popup-open');

    if (remember) {
      const state = readState(popup.dataset.sectionId);
      writeState(popup.dataset.sectionId, { ...state, closedAt: Date.now() });
    }

    if (showTeaser && popup.dataset.showTeaser === 'true' && canDisplay(popup)) {
      getTeaser(popup.dataset.sectionId)?.removeAttribute('hidden');
    }

    previousFocus?.focus?.({ preventScroll: true });
  };

  const syncExtraFieldsToTags = (popup) => {
    const tags = popup.querySelector('[data-fbp-tags]');
    if (!(tags instanceof HTMLInputElement)) return;

    const base = tags.defaultValue || tags.value || 'newsletter, Forever Bloom Popup';
    const extra = [];

    popup.querySelectorAll('[data-fbp-field]').forEach((field) => {
      if (!(field instanceof HTMLInputElement)) return;
      if (!field.value.trim() || field.dataset.fieldType === 'email') return;
      const label = field.dataset.fieldLabel || field.dataset.fieldType || 'Dato';
      const clean = field.value.trim().replace(/,/g, ' ');
      extra.push(`${label}: ${clean}`);
    });

    tags.value = [base, ...extra].filter(Boolean).join(', ');
  };

  const bindCopy = (popup) => {
    popup.querySelector('[data-fbp-copy]')?.addEventListener('click', async (event) => {
      const button = event.currentTarget;
      if (!(button instanceof HTMLElement)) return;
      const code = button.dataset.fbpCopy || '';
      try {
        await navigator.clipboard.writeText(code);
        const label = button.querySelector('[data-fbp-copy-label]');
        if (label) {
          const original = label.textContent;
          label.textContent = 'Copiado';
          setTimeout(() => {
            label.textContent = original || 'Copiar';
          }, 1400);
        }
      } catch {}
    });
  };

  const init = (popup) => {
    if (!(popup instanceof HTMLElement) || popup.dataset.fbPromoReady === 'true') return;
    popup.dataset.fbPromoReady = 'true';

    const id = popup.dataset.sectionId;
    const teaser = getTeaser(id);

    popup.querySelectorAll('[data-fbp-close]').forEach((button) => {
      button.addEventListener('click', () => hide(popup, true, true));
    });

    popup.querySelector('[data-fbp-overlay]')?.addEventListener('click', () => {
      if (popup.dataset.overlayClose === 'true') hide(popup, true, true);
    });

    teaser?.addEventListener('click', () => show(popup, true));

    popup.querySelector('form')?.addEventListener('submit', () => {
      syncExtraFieldsToTags(popup);
    });

    bindCopy(popup);

    if (popup.querySelector('[data-fbp-success]')) {
      const state = readState(id);
      writeState(id, { ...state, successAt: Date.now(), closedAt: null });
      show(popup, true);
      return;
    }

    if (window.Shopify?.designMode) return;
    if (!canDisplay(popup)) return;

    if (isSuppressed(popup)) {
      if (popup.dataset.showTeaser === 'true') teaser?.removeAttribute('hidden');
      return;
    }

    window.setTimeout(() => {
      if (!openPopup) show(popup);
    }, Number(popup.dataset.delay || 0));
  };

  const boot = (root = document) => {
    root.querySelectorAll?.('[data-fb-promo-popup]').forEach(init);
  };

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && openPopup) hide(openPopup, true, true);
  });

  document.addEventListener('shopify:section:load', (event) => boot(event.target));

  document.addEventListener('shopify:section:select', (event) => {
    const popup = event.target?.querySelector?.('[data-fb-promo-popup]');
    if (popup) show(popup, true);
  });

  document.addEventListener('shopify:section:deselect', (event) => {
    const popup = event.target?.querySelector?.('[data-fb-promo-popup]');
    if (popup && !popup.hidden) hide(popup, false, false);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot());
  } else {
    boot();
  }
})();
